import { FaMinus, FaPlus } from 'react-icons/fa';
import { GoTrash } from 'react-icons/go';
import { useStateContext } from '../contexts/ContextProvider';
import { useState } from 'react';
import useIsMobileDevice from '../hooks/useIsMobileDevice';

const CartItem = ({ document, product, selectAll, selectedItems, setSelectedItems }) => {
    const {cartItems, setCartItems} = useStateContext();
    const item = document || product;
    const [quantity, setQuantity] = useState(item.quantity);
    const isMobileDevice = useIsMobileDevice();

    const handleRemoveFromCart = () => {
        const updatedCartItems = product ? (
            cartItems.products.filter(item => item.slug !== product.slug)
        ) : (
            cartItems.documents.filter(item => item.docNumber !== document.docNumber)
        );

        if (product) {
            setCartItems({
                ...cartItems,
                products: updatedCartItems
            });
        } else {
            setCartItems({
                ...cartItems,
                documents: updatedCartItems
            });
        }
    };
    
    const handleQuantityChange = (action) => {
        let newQuantity = quantity;
        if (action === 'increment') {
            newQuantity++;
        } else if (action === 'decrement' && quantity > 1) {
            newQuantity--;
        }
        setQuantity(newQuantity);
        
        // Update the cartItems state
        if (product) {
            setCartItems({
                ...cartItems,
                products: cartItems.products.map(prd => {
                    if (prd.slug === product.slug) {
                        return { ...item, quantity: newQuantity };
                    }
                    return item;
                })
            });
        } else {
            setCartItems({
                ...cartItems,
                documents: cartItems.documents.map(doc => {
                    if (doc.docNumber === document.docNumber) {
                        return { ...item, quantity: newQuantity };
                    }
                    return item;
                })
            });
        }
    };

    return (
      <div className='flex flex-row  items-center'>
        {selectAll ?  (
          <input
            type="checkbox"
            checked={selectAll}
            name={item.name || item.file.name}
            className={`mr-2 ${isMobileDevice ? 'w-[10%]' : 'w-[2%]'}`}
            onChange={() => {}}
          />
        ) : (
            <input
                type="checkbox"
                name="product"
                className={`mr-2 ${isMobileDevice ? 'w-[10%]' : 'w-[2%]'}`}
                checked={selectedItems.includes(item)}
                onChange={() => {
                    if (selectedItems.includes(item)) {
                        setSelectedItems(selectedItems.filter(item => item !== item));
                    } else {
                        setSelectedItems([...selectedItems, item]);
                    }
                }}
            />
        )}
        
        <div className={`${isMobileDevice ? 'w-[90%]' : 'w-[98%]'} flex flex-row mb-2  p-2 min-h-[150px] border border-gray-300 shadow-md rounded-md`}>
            {item.imageUrl && <img src={item.imageUrl} alt={item.name} className="w-28 h-28 object-cover rounded bg-gray-200 text-center mx-auto" />}
            <div className="basis-1/2 flex-grow mx-4">
                <h3 className="text-lg font-semibold">{item.name || item.file.name}</h3>
                <div className="text-gray-500">{
                    item.description
                    ||
                    <div>
                        <ul className="list-disc list-inside">
                            <li>Paper format: {item.paperFormat}</li>
                            <li>Print Option: {item.printOption}</li>
                            <li>Print Color: {item.printColor}</li>
                            <li>Paper Orientation: {item.paperOrientation}</li>
                            <li>Add Cover Page: {item.addCoverPage ? 'Yes' : 'No'}</li>
                            <li>Paper Fastening: {item.paperFasteningChoice}</li>
                            <li>Page Range: {item.pageRange}</li>
                            {item.additionalNotes && <li>Additional Notes: {item.additionalNotes}</li>}
                        </ul>
                     </div>
                }</div>
                <h1 className='text-lg font-bold text-green-400'>DA {item.price}</h1>
            </div>
            
            <div className='basis-1/4 flex-grow my-2'>
                
                <div className='w-full h-full flex flex-col justify-between items-end'>
                    <button
                        title='Remove from cart'
                        className='border border-gray-400 hover:text-white p-2 rounded-md hover:bg-blue-500'
                        onClick={handleRemoveFromCart}
                    >
                        <GoTrash />
                    </button>
                    <div className='flex flex-row items-center gap-2'>
                        
                        <div className='flex flex-row w-full text-xs items-center justify-center border border-gray-400 rounded-md p-0.5'>
                            <button
                                className='p-2 hover:text-white rounded-md hover:bg-blue-500'
                                onClick={() => handleQuantityChange('increment')}
                            >
                                <FaPlus />
                            </button>
                            <div className='border-l border-gray-400 h-full'></div> {/* Separator */}
                            <button
                                className='p-2 hover:text-white rounded-md hover:bg-blue-500'
                                onClick={() => handleQuantityChange('decrement')}
                            >
                                <FaMinus />
                            </button>
                        </div>
                        <span className='font-semibold text-sm'>{quantity}</span>
                    </div>
                </div>
            </div>
        </div>



      </div>
    );
  }

export default CartItem;